import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, inject, NO_ERRORS_SCHEMA, OnInit, SimpleChanges } from '@angular/core';

import { ButtonsAndIndicatorsModule } from '@one/angular/dist/buttons-and-indicators';
import { LayoutModule } from '@one/angular/dist/layout';
import { NavigationModule } from '@one/angular/dist/navigation';

import { AuthService } from '../../core/auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {NotificationDetailsService} from '../qn-sbn-eservice/notification/notification-details/notification-details.service'

@Component({
  selector: 'dl-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  schemas: [NO_ERRORS_SCHEMA],
  imports: [NgIf, ButtonsAndIndicatorsModule, NavigationModule, LayoutModule],
})
export class HeaderComponent implements OnInit {
  readonly authService = inject(AuthService);
  private router = inject(Router);
  public activeTab: string = '';
  isAdding:boolean=false;

  profileData: { name: string; email: string; initials: string } | null = null;

  constructor(public notificationDetailsService: NotificationDetailsService,
    private _cdr: ChangeDetectorRef){}

  ngOnInit(): void {
    this.setUserProfileData();
    this.setActiveTabFromUrl();
    
    // Listen to router events to update active tab on navigation
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setActiveTabFromUrl();
    });

    this.notificationDetailsService.diableFullScreen$.subscribe(val=>{
      this.isAdding=val;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.notificationDetailsService.diableFullScreen$.subscribe(val=>{
      this.isAdding=val;
    })
    this._cdr.detectChanges();
  }

  private setActiveTabFromUrl(): void {
    const url = this.router.url;
    if (url.includes('/dashboard')) {
      this.activeTab = 'dashboard';
    } else if (url.includes('/notification')) {
      this.activeTab = 'notification';
    } else if (url.includes('/email-delivery')) {
      this.activeTab = 'email-delivery';
    } else {
      this.activeTab = 'notification'; // default
    }
  }

  logout(): void {
    this.authService.signOut();
  }

  private setUserProfileData(): void {
    this.profileData = {
      name: localStorage.getItem('name') ?? '',
      email: localStorage.getItem('email') ?? '',
      initials: localStorage.getItem('initials') ?? '',
    };
  }

 

 public toNotification():void {
    this.activeTab = 'notification';
    this.router.navigateByUrl('/notification');
  }

  public toDashboard():void {
    this.activeTab = 'dashboard';
    this.router.navigateByUrl('/dashboard');
  }

  public toEmailDelivery():void {
    this.activeTab = 'email-delivery';
    this.router.navigateByUrl('/email-delivery');
  }
}
